import { ref, onMounted, inject } from 'vue';
import captions from '@/content/gallery-captions.json';

const cache = new Map();
const prefix = process.env.VUE_APP_API_ORIGIN || '';

export function useGallery(name) {
  const seed = inject('gallerySeed', {});
  const formatImages = (urls) =>
    urls
      .slice()
      .reverse()
      .filter((url) => typeof url === 'string' && url.startsWith('/galleries/'))
      .map((url, index) => ({
        src: `${prefix}${url}`,
        title:
          captions[url] ||
          `${
            name.startsWith('art')
              ? 'Kunstwerk'
              : name.startsWith('aboutme')
              ? 'Rebecca Sophia'
              : 'Tattoo'
          } ${index + 1} – White Pearl Ink`,
      }));
  const images = ref(cache.get(name) || formatImages(seed[name] || []));
  const loading = ref(!images.value.length);
  const error = ref(false);
  const load = async () => {
    error.value = false;
    loading.value = !images.value.length;
    try {
      const response = await fetch(`${prefix}/api/galleries/${encodeURIComponent(name)}`);
      if (!response.ok) throw new Error('Gallery unavailable');
      const urls = await response.json();
      if (!Array.isArray(urls)) throw new Error('Invalid gallery');
      images.value = formatImages(urls);
      cache.set(name, images.value);
    } catch {
      error.value = true;
    } finally {
      loading.value = false;
    }
  };
  onMounted(() => {
    // Refresh a build-time snapshot once; subsequent route visits can use the live cache.
    if (!cache.has(name)) load();
  });
  return { images, loading, error, load };
}
